import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './components/ThemeProvider';
import { AppProviders } from '@/core/providers/AppProviders';
import { AuthProvider } from '@/features/auth';
import App from './App';


import './index.css';


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppProviders>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AppProviders>
    </ThemeProvider>
  </React.StrictMode>
); 